import React, { useEffect } from "react";

const GoogleTranslate = () => {
  const addGoogleTranslateScript = () => {
    const script = document.createElement("script");
    script.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;

    script.onload = () => {
      if (typeof window.google !== "undefined" && window.google.translate) {
        // Initialize only if the element has not been initialized yet
        if (!window.googleTranslateElementInit) {
          window.googleTranslateElementInit = () => {
            if (typeof window.google !== "undefined" && window.google.translate) {
              new window.google.translate.TranslateElement(
                { pageLanguage: "en", layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE },
                "google_translate_element"
              );
            } else {
              console.error("Google Translate library not loaded");
            }
          };
        }

        window.googleTranslateElementInit(); // Initialize the translate element
      } else {
        console.error("Google Translate library not loaded");
      }
    };

    script.onerror = () => {
      console.error("Failed to load Google Translate script");
    };

    document.body.appendChild(script);
  };

  useEffect(() => {
    // Only add script if not already added
    if (!document.querySelector('script[src="https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"]')) {
      addGoogleTranslateScript();
    }
  }, []);

  return (
    <div
      id="google_translate_element"
    />
  );
};

export default GoogleTranslate;